export const grey = '#e2d6e2';
export const beige = '#ebdfb1';
